import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { OrganisationService } from 'app/core/organisation/organisation.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Guard to check if an organization exists for the given slug in the URL.
 * If not found, redirects to the 404/unauthorized page.
 */
@Injectable({ providedIn: 'root' })
export class SlugExistsGuard implements CanActivate {
    constructor(
        private router: Router,
        private organisationService: OrganisationService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const slug = route.paramMap.get('slug');
        if (!slug) {
            return of(this.router.createUrlTree(['/unauthorized']));
        }
        return this.organisationService.loadBySlug(slug).pipe(
            map(() => true),
            catchError(() => of(this.router.createUrlTree(['/unauthorized'])))
        );
    }
}
